<template>
    <div id="footer">
        <small>
            © 2017 Alex van Vliet All Rights Reserved
            <br>
            Credits : <a href="https://www.behance.net/gallery/34290349/23XX-Free-Font">font</a>
        </small>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'footer'
    }
</script>



// WEBPACK FOOTER //
// Footer.vue?691bea36